import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

// Servicio personalizado para peticiones JWT
//import { JwtRequestService } from '../jwt-request.service';
import { JwtRequestService } from '../../../jwt-request.service';

@Component({
  selector: 'app-tramite-titulo',
  templateUrl: './tramite-titulo.component.html',
  styleUrls: ['tramite-titulo.component.css']
})
export class TramiteTituloComponent implements OnInit {
  tramiteForm: FormGroup;
  isLoading = false;
  errorMessage = '';
  successMessage = '';
  showLoadingOverlay = false;

   // Nueva variable para el modal de profesionista
  showProfesionistaModal = false;
  profesionistasResultados: any[] = [];
  terminoBusqueda = '';


  // Nueva variable para el select de firmantes
  firmantesTitulos: any[] = [];

   // Opciones para el select de cumplio servicio social
  serviciosSociales = [
    { id: 1, nombre: 'SI' },
    { id: 0, nombre: 'NO' }
  ];

    // Opciones para el select de cargos
  cargos = [
    { id: '1', nombre: 'DIRECTOR' },
    { id: '2', nombre: 'SUBDIRECTOR' },
    { id: '3', nombre: 'RECTOR' },
    { id: '4', nombre: 'VICERRECTOR' },
    { id: '5', nombre: 'RESPONSABLE DE EXPEDICIÓN' },
    { id: '6', nombre: 'SECRETARIO GENERAL' },
    { id: '7', nombre: 'AUTORIDAD LOCAL' },
    { id: '8', nombre: 'AUTORIDAD FEDERAL' },
    { id: '9', nombre: 'DIRECTOR GENERAL' }
  ];

  // Opciones para el select de fundamento legal
  fundamentosLegales = [
    { id: 1, texto: 'ART. 52 LRART. 5 CONST' },
    { id: 2, texto: 'ART. 55 LRART. 5 CONST' },
    { id: 3, texto: 'ART. 91 RLRART. 5 CONST' },
    { id: 4, texto: 'ART. 10 REGLAMENTO PARA LA PRESTACIÓN DEL SERVICIO SOCIAL DE LOS ESTUDIANTES DE LAS INSTITUCIONES DE EDUCACIÓN SUPERIOR EN LA REPÚBLICA MEXICANA' },
    { id: 5, texto: 'NO APLICA' }
  ];

  // Opciones para el select de entidades federativas
  entidadesFederativas = [
    { id: '01', nombre: 'AGUASCALIENTES' },
    { id: '02', nombre: 'BAJA CALIFORNIA' },
    { id: '03', nombre: 'BAJA CALIFORNIA SUR' },
    { id: '04', nombre: 'CAMPECHE' },
    { id: '05', nombre: 'COAHUILA DE ZARAGOZA' },
    { id: '06', nombre: 'COLIMA' },
    { id: '07', nombre: 'CHIAPAS' },
    { id: '08', nombre: 'CHIHUAHUA' },
    { id: '09', nombre: 'CIUDAD DE MÉXICO' },
    { id: '10', nombre: 'DURANGO' },
    { id: '11', nombre: 'GUANAJUATO' },
    { id: '12', nombre: 'GUERRERO' },
    { id: '13', nombre: 'HIDALGO' },
    { id: '14', nombre: 'JALISCO' },
    { id: '15', nombre: 'MÉXICO' },
    { id: '16', nombre: 'MICHOACÁN DE OCAMPO' },
    { id: '17', nombre: 'MORELOS' },
    { id: '18', nombre: 'NAYARIT' },
    { id: '19', nombre: 'NUEVO LEÓN' },
    { id: '20', nombre: 'OAXACA' },
    { id: '21', nombre: 'PUEBLA' },
    { id: '22', nombre: 'QUERÉTARO' },
    { id: '23', nombre: 'QUINTANA ROO' },
    { id: '24', nombre: 'SAN LUIS POTOSÍ' },
    { id: '25', nombre: 'SINALOA' },
    { id: '26', nombre: 'SONORA' },
    { id: '27', nombre: 'TABASCO' },
    { id: '28', nombre: 'TAMAULIPAS' },
    { id: '29', nombre: 'TLAXCALA' },
    { id: '30', nombre: 'VERACRUZ DE IGNACIO DE LA LLAVE' },
    { id: '31', nombre: 'YUCATÁN' },
    { id: '32', nombre: 'ZACATECAS' },
    { id: '33', nombre: 'EXTRANJERO' }
  ];

  // Opciones para el select de modalidad de titulación
  modalidadesTitulacion = [
    { id: '1', nombre: 'POR TESIS' },
    { id: '2', nombre: 'POR PROMEDIO' },
    { id: '3', nombre: 'POR ESTUDIOS DE POSGRADOS' },
    { id: '4', nombre: 'POR EXPERIENCIA LABORAL' },
    { id: '5', nombre: 'POR CENEVAL' },
    { id: '6', nombre: 'OTRO' }
  ];

  // Opciones para el select de tipo de estudio antecedente
  tiposEstudioAntecedente = [
    { id: '1', nombre: 'MAESTRÍA' },
    { id: '2', nombre: 'LICENCIATURA' },
    { id: '3', nombre: 'TÉCNICO SUPERIOR UNIVERSITARIO' },
    { id: '4', nombre: 'BACHILLERATO' },
    { id: '5', nombre: 'EQUIVALENTE A BACHILLERATO' },
    { id: '6', nombre: 'SECUNDARIA' }
  ];

  // Opciones para el select de autorización reconocimiento
  autorizacionesReconocimiento = [
    { id: '1', nombre: 'RVOE FEDERAL' },
    { id: '2', nombre: 'RVOE ESTATAL' },
    { id: '3', nombre: 'AUTORIZACIÓN FEDERAL' },
    { id: '4', nombre: 'AUTORIZACIÓN ESTATAL' },
    { id: '5', nombre: 'ACTA DE SESIÓN' },
    { id: '6', nombre: 'ACUERDO DE INCORPORACIÓN' },
    { id: '7', nombre: 'ACUERDO SECRETARIAL SEP' },
    { id: '8', nombre: 'DECRETO DE CREACIÓN' },
    { id: '9', nombre: 'OTRO' }
  ];

  constructor(
    private fb: FormBuilder,
    private jwtRequest: JwtRequestService,
    private router: Router
  ) {
    this.tramiteForm = this.createForm();
  }

  ngOnInit(): void {
        this.cargarFirmantesTitulos();
  }


    // Método para abrir el modal y buscar profesionistas
  buscarProfesionista(): void {
    this.terminoBusqueda = this.tramiteForm.get('profesionista_buscar')?.value || '';
    
    if (!this.terminoBusqueda.trim()) {
      this.errorMessage = 'Por favor ingrese un término de búsqueda';
      return;
    }

    this.showProfesionistaModal = true;
    this.isLoading = true;
    this.showLoadingOverlay = true;

    this.jwtRequest.get(`profesionista-auto?term=${encodeURIComponent(this.terminoBusqueda)}`)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 200) {
            this.profesionistasResultados = response.data || [];
            if (this.profesionistasResultados.length === 0) {
              this.errorMessage = 'No se encontraron resultados para la búsqueda';
            }
          } else {
            this.errorMessage = response.messages || 'Error al buscar profesionistas';
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          if (error.error && error.error.messages) {
            this.errorMessage = error.error.messages;
          } else {
            this.errorMessage = 'Error de conexión al buscar profesionistas';
          }
        }
      });
  }

  // Método para asignar el profesionista seleccionado
  asignarProfesionista(profesionista: any): void {
    // Asignar valores al formulario
    this.tramiteForm.patchValue({
      personas_id : profesionista.id,  
      curpProfesionista: profesionista.curp || '',
      nombreProfesionista: profesionista.nombre || '',
      primerApellidoProfesionista: profesionista.apellido_paterno || '',
      segundoApellidoProfesionista: profesionista.apellido_materno || '',
      correoElectronico: profesionista.email || '',
      cveCarrera: profesionista.carreras?.clave_carrera || '',
      nombreCarrera: profesionista.carreras?.nombre || '',
      numeroRvoe: profesionista.carreras?.rvoe || ''
    });

    // Cerrar el modal
    this.showProfesionistaModal = false;
    this.profesionistasResultados = [];
  }

  // Método para cerrar el modal sin hacer cambios
  cerrarModalProfesionista(): void {
    this.showProfesionistaModal = false;
    this.profesionistasResultados = [];
    this.terminoBusqueda = '';
  }



  // Método para cargar los firmantes desde la API
  cargarFirmantesTitulos(): void {
    this.isLoading = true;
    this.showLoadingOverlay = true;
    
    this.jwtRequest.get('firmante-titulo')
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 200) {
            this.firmantesTitulos = response.data || [];
          } else {
            this.errorMessage = response.messages || 'Error al cargar los firmantes';
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          if (error.error && error.error.messages) {
            this.errorMessage = error.error.messages;
          } else {
            this.errorMessage = 'Error de conexión al cargar los firmantes';
          }
        }
      });
  }


 // Método para manejar el cambio en el select de firmantes (Responsable 1)
onFirmanteTituloChange(event: any): void {
  const selectedId = parseInt(event.target.value);
  const firmanteSeleccionado = this.firmantesTitulos.find(f => f.id === selectedId);
  
  if (firmanteSeleccionado) {
    // Actualizar el valor del select
    this.tramiteForm.patchValue({
      firmantes_titulos_id: selectedId
    });

    // Llenar todos los campos de la card Firma del Responsable
    this.tramiteForm.patchValue({
      nombreResponsable: firmanteSeleccionado.nombre,
      primerApellidoResponsable: firmanteSeleccionado.primerApellido,
      segundoApellidoResponsable: firmanteSeleccionado.segundoApellido,
      curpResponsable: firmanteSeleccionado.curp,
      idCargo: firmanteSeleccionado.idCargo.toString(),
      cargo: firmanteSeleccionado.cargo,
      abrTitulo: firmanteSeleccionado.abrTitulo
    });

    // También actualizar el campo cargo si existe en el array de cargos
    const cargoCorrespondiente = this.cargos.find(c => c.id === firmanteSeleccionado.idCargo.toString());
    if (cargoCorrespondiente) {
      this.tramiteForm.patchValue({
        cargo: cargoCorrespondiente.nombre
      });
    }
  } else {
    // Limpiar campos si no hay selección
    this.tramiteForm.patchValue({
      firmantes_titulos_id: '',
      nombreResponsable: '',
      primerApellidoResponsable: '',
      segundoApellidoResponsable: '',
      curpResponsable: '',
      idCargo: '',
      cargo: '',
      abrTitulo: ''
    });
  }
}

  // Método para manejar el cambio en el select de firmantes (Responsable 2)
onFirmanteTituloChange2(event: any): void {
  const selectedId = parseInt(event.target.value);
  const firmanteSeleccionado = this.firmantesTitulos.find(f => f.id === selectedId);
  
  if (firmanteSeleccionado) {
    // Actualizar el valor del select
    this.tramiteForm.patchValue({
      firmantes_titulos_id2: selectedId
    });

    // Llenar todos los campos de la card Firma del Responsable 2
    this.tramiteForm.patchValue({
      nombreResponsable2: firmanteSeleccionado.nombre,
      primerApellidoResponsable2: firmanteSeleccionado.primerApellido,
      segundoApellidoResponsable2: firmanteSeleccionado.segundoApellido,
      curpResponsable2: firmanteSeleccionado.curp,
      idCargo2: firmanteSeleccionado.idCargo.toString(),
      cargo2: firmanteSeleccionado.cargo,
      abrTitulo2: firmanteSeleccionado.abrTitulo
    });

    // También actualizar el campo cargo si existe en el array de cargos
    const cargoCorrespondiente = this.cargos.find(c => c.id === firmanteSeleccionado.idCargo.toString());
    if (cargoCorrespondiente) {
      this.tramiteForm.patchValue({
        cargo2: cargoCorrespondiente.nombre
      });
    }
  } else {
    // Limpiar campos si no hay selección
    this.tramiteForm.patchValue({
      firmantes_titulos_id2: '',
      nombreResponsable2: '',
      primerApellidoResponsable2: '',
      segundoApellidoResponsable2: '',
      curpResponsable2: '',
      idCargo2: '',
      cargo2: '',
      abrTitulo2: ''
    });
  }
}



createForm(): FormGroup {
  return this.fb.group({

    // Nuevo campo para búsqueda de profesionista
      profesionista_buscar: [''],

      personas_id:undefined,

    // TituloElectronico
    version: ['1.0', [Validators.required, Validators.min(0), Validators.max(9.9)]],
    folioControl: ['', [Validators.required, Validators.maxLength(55)]],

    // Selects de firmantes
    firmantes_titulos_id: ['', [Validators.required]],
    firmantes_titulos_id2: ['', [Validators.required]],

    // FirmaResponsable (Responsable 1)
    nombreResponsable: ['', [Validators.required, Validators.maxLength(55)]],
    primerApellidoResponsable: ['', [Validators.required, Validators.maxLength(55)]],
    segundoApellidoResponsable: ['', [Validators.required, Validators.maxLength(55)]],
    curpResponsable: ['', [Validators.required, Validators.maxLength(20)]],
    idCargo: ['', [Validators.required]],
    cargo: ['', [Validators.required, Validators.maxLength(155)]],
    abrTitulo: ['', [Validators.maxLength(55)]],

    // FirmaResponsable2 (Responsable 2)
    nombreResponsable2: ['', [Validators.required, Validators.maxLength(55)]],
    primerApellidoResponsable2: ['', [Validators.required, Validators.maxLength(55)]],
    segundoApellidoResponsable2: ['', [Validators.required, Validators.maxLength(55)]],
    curpResponsable2: ['', [Validators.required, Validators.maxLength(20)]],
    idCargo2: ['', [Validators.required]],
    cargo2: ['', [Validators.required, Validators.maxLength(155)]],
    abrTitulo2: ['', [Validators.maxLength(55)]],

    // ... el resto de los campos permanece igual ...
    // Institucion
    cveInstitucion: ['070413', [Validators.required]],
    nombreInstitucion: ['INSTITUTO EN CIENCIAS DE LA SALUD Y MEDICINA INTEGRAL SAMUEL HAHNEMANN', [Validators.required, Validators.maxLength(255)]],

    // Carrera
    cveCarrera: ['', [Validators.required]],
    nombreCarrera: ['', [Validators.required, Validators.maxLength(255)]],
    fechaInicioCarrera: [''],
    fechaTerminacionCarrera: ['', [Validators.required]],
    idAutorizacionReconocimiento: ['', [Validators.required]],
    autorizacionReconocimiento: ['', [Validators.required, Validators.maxLength(255)]],
    numeroRvoe: [''],

    // Profesionista
    curpProfesionista: ['', [Validators.required, Validators.maxLength(20)]],
    nombreProfesionista: ['', [Validators.required, Validators.maxLength(55)]],
    primerApellidoProfesionista: ['', [Validators.required, Validators.maxLength(55)]],
    segundoApellidoProfesionista: ['', [Validators.maxLength(55)]],
    correoElectronico: ['', [Validators.required, Validators.email, Validators.maxLength(155)]],

    // Expedicion
    fechaExpedicion: ['', [Validators.required]],
    idModalidadTitulacion: ['', [Validators.required, Validators.maxLength(11)]],
    modalidadTitulacion: ['', [Validators.required, Validators.maxLength(55)]],
    fechaExamenProfesional: [''],
    fechaExencionExamenProfesional: [''],
    cumplioServicioSocial: ['', [Validators.required, Validators.maxLength(10)]],
    idFundamentoLegalServicioSocial: ['', [Validators.required]],
    fundamentoLegalServicioSocial: ['', [Validators.required, Validators.maxLength(255)]],
    idEntidadFederativaExpedicion: ['', [Validators.required]],
    entidadFederativaExpedicion: ['', [Validators.required, Validators.maxLength(55)]],

    // Antecedente
    institucionProcedencia: ['', [Validators.required, Validators.maxLength(255)]],
    idTipoEstudioAntecedente: ['', [Validators.required]],
    tipoEstudioAntecedente: ['', [Validators.required, Validators.maxLength(55)]],
    idEntidadFederativaAntecedente: ['', [Validators.required]],
    entidadFederativaAntecedente: ['', [Validators.required, Validators.maxLength(55)]],
    fechaInicioAntecedente: [''],
    fechaTerminacionAntecedente: ['', [Validators.required]],
    noCedula: ['', [Validators.maxLength(55)]]
  });
}



  // Método para validar campos de la segunda card
  isFieldInvalid2(fieldName: string): boolean {
    const field = this.tramiteForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }



    // Método para manejar el cambio en el select de cargo
  onCargoChange(event: any): void {
    const selectedId = event.target.value;
    const cargoSeleccionado = this.cargos.find(c => c.id === selectedId);
    
    if (cargoSeleccionado) {
      this.tramiteForm.patchValue({
        cargo: cargoSeleccionado.nombre
      });
    } else {
      this.tramiteForm.patchValue({
        cargo: ''
      });
    }
  }


  // Método para manejar el cambio en el select de cargo (Responsable 2)
  onCargoChange2(event: any): void {
    const selectedId = event.target.value;
    const cargoSeleccionado = this.cargos.find(c => c.id === selectedId);
    
    if (cargoSeleccionado) {
      this.tramiteForm.patchValue({
        cargo2: cargoSeleccionado.nombre
      });
    } else {
      this.tramiteForm.patchValue({
        cargo2: ''
      });
    }
  }

  // Método para manejar el cambio en el select de fundamento legal
  onFundamentoLegalChange(event: any): void {
    const selectedId = parseInt(event.target.value);
    const fundamentoSeleccionado = this.fundamentosLegales.find(f => f.id === selectedId);
    
    if (fundamentoSeleccionado) {
      this.tramiteForm.patchValue({
        fundamentoLegalServicioSocial: fundamentoSeleccionado.texto
      });
    } else {
      this.tramiteForm.patchValue({
        fundamentoLegalServicioSocial: ''
      });
    }
  }

  // Método para manejar el cambio en el select de entidad federativa
  onEntidadFederativaChange(event: any): void {
    const selectedId = event.target.value;
    const entidadSeleccionada = this.entidadesFederativas.find(e => e.id === selectedId);
    
    if (entidadSeleccionada) {
      this.tramiteForm.patchValue({
        entidadFederativaExpedicion: entidadSeleccionada.nombre
      });
    } else {
      this.tramiteForm.patchValue({
        entidadFederativaExpedicion: ''
      });
    }
  }

  // Método para manejar el cambio en el select de modalidad de titulación
  onModalidadTitulacionChange(event: any): void {
    const selectedId = event.target.value;
    const modalidadSeleccionada = this.modalidadesTitulacion.find(m => m.id === selectedId);
    
    if (modalidadSeleccionada) {
      this.tramiteForm.patchValue({
        modalidadTitulacion: modalidadSeleccionada.nombre
      });
    } else {
      this.tramiteForm.patchValue({
        modalidadTitulacion: ''
      });
    }
  }

  // Método para manejar el cambio en el select de tipo de estudio antecedente
  onTipoEstudioAntecedenteChange(event: any): void {
    const selectedId = event.target.value;
    const tipoEstudioSeleccionado = this.tiposEstudioAntecedente.find(t => t.id === selectedId);
    
    if (tipoEstudioSeleccionado) {
      this.tramiteForm.patchValue({
        tipoEstudioAntecedente: tipoEstudioSeleccionado.nombre
      });
    } else {
      this.tramiteForm.patchValue({
        tipoEstudioAntecedente: ''
      });
    }
  }

  // Método para manejar el cambio en el select de autorización reconocimiento
  onAutorizacionReconocimientoChange(event: any): void {
    const selectedId = event.target.value;
    const autorizacionSeleccionada = this.autorizacionesReconocimiento.find(a => a.id === selectedId);
    
    if (autorizacionSeleccionada) {
      this.tramiteForm.patchValue({
        autorizacionReconocimiento: autorizacionSeleccionada.nombre
      });
    } else {
      this.tramiteForm.patchValue({
        autorizacionReconocimiento: ''
      });
    }
  }

  // Método para manejar el cambio en el select de entidad federativa antecedente
  onEntidadFederativaAntecedenteChange(event: any): void {
    const selectedId = event.target.value;
    const entidadSeleccionada = this.entidadesFederativas.find(e => e.id === selectedId);
    
    if (entidadSeleccionada) {
      this.tramiteForm.patchValue({
        entidadFederativaAntecedente: entidadSeleccionada.nombre
      });
    } else {
      this.tramiteForm.patchValue({
        entidadFederativaAntecedente: ''
      });
    }
  }

  onSubmit(): void {
    if (this.tramiteForm.valid) {
      this.isLoading = true;
      this.showLoadingOverlay = true;
      this.errorMessage = '';
      this.successMessage = '';

      this.jwtRequest.post('tramite-titulo', this.tramiteForm.value)
        .subscribe({
          next: (response: any) => {
            this.isLoading = false;
            this.showLoadingOverlay = false;
            
            if (response.status === 200) {
              this.successMessage = response.messages || 'Trámite creado exitosamente';
              this.scrollToTop(); // ← Agregar esta línea
              this.tramiteForm.reset();
              setTimeout(() => {
                // this.router.navigate(['/lista-tramites']); // Opcional: redirigir a lista
              }, 2000);
            } else {
              this.errorMessage = response.messages || 'Error desconocido';
              this.scrollToTop(); // ← Agregar esta línea
            }
          },
          error: (error) => {
            this.isLoading = false;
            this.showLoadingOverlay = false;
            if (error.error && error.error.messages) {
              this.errorMessage = error.error.messages;
            } else {
              this.errorMessage = 'Error de conexión con el servidor';
            }
            this.scrollToTop(); // ← Agregar esta línea
          }
        });
    } else {
      this.markFormGroupTouched();
      this.errorMessage = 'Por favor, complete todos los campos requeridos correctamente';
      this.scrollToTop(); // ← Agregar esta línea
    }
  }

    // Función para desplazar al top del formulario
  private scrollToTop(): void {
    setTimeout(() => {
      const contentScrollable = document.querySelector('.content-scrollable');
      if (contentScrollable) {
        contentScrollable.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }, 100);
  }

  private markFormGroupTouched(): void {
    Object.keys(this.tramiteForm.controls).forEach(key => {
      const control = this.tramiteForm.get(key);
      control?.markAsTouched();
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.tramiteForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }



  // Agrega esta función en la clase TramiteTituloComponent

    // Función única para validar el estado de cada card
    isCardValid(cardName: string): boolean {
      switch (cardName) {
        case 'tituloElectronico':
          return !!(this.tramiteForm.get('version')?.value && 
                    this.tramiteForm.get('folioControl')?.value);

        case 'institucion':
          return !!(this.tramiteForm.get('cveInstitucion')?.value && 
                    this.tramiteForm.get('nombreInstitucion')?.value);

        case 'profesionista':
          return !!(this.tramiteForm.get('curpProfesionista')?.value && 
                    this.tramiteForm.get('nombreProfesionista')?.value && 
                    this.tramiteForm.get('primerApellidoProfesionista')?.value && 
                    this.tramiteForm.get('correoElectronico')?.value);

        case 'carrera':
          return !!(this.tramiteForm.get('cveCarrera')?.value && 
                    this.tramiteForm.get('nombreCarrera')?.value && 
                    this.tramiteForm.get('idAutorizacionReconocimiento')?.value && 
                    this.tramiteForm.get('autorizacionReconocimiento')?.value && 
                    this.tramiteForm.get('fechaTerminacionCarrera')?.value);

        case 'expedicion':
          return !!(this.tramiteForm.get('fechaExpedicion')?.value && 
                    this.tramiteForm.get('idModalidadTitulacion')?.value && 
                    this.tramiteForm.get('modalidadTitulacion')?.value && 
                    this.tramiteForm.get('cumplioServicioSocial')?.value && 
                    this.tramiteForm.get('idFundamentoLegalServicioSocial')?.value && 
                    this.tramiteForm.get('fundamentoLegalServicioSocial')?.value && 
                    this.tramiteForm.get('idEntidadFederativaExpedicion')?.value && 
                    this.tramiteForm.get('entidadFederativaExpedicion')?.value);

        case 'antecedente':
          return !!(this.tramiteForm.get('institucionProcedencia')?.value && 
                    this.tramiteForm.get('idTipoEstudioAntecedente')?.value && 
                    this.tramiteForm.get('tipoEstudioAntecedente')?.value && 
                    this.tramiteForm.get('idEntidadFederativaAntecedente')?.value && 
                    this.tramiteForm.get('entidadFederativaAntecedente')?.value && 
                    this.tramiteForm.get('fechaTerminacionAntecedente')?.value);

        case 'firmaResponsable':
          return !!(this.tramiteForm.get('firmantes_titulos_id')?.value && 
                    this.tramiteForm.get('nombreResponsable')?.value && 
                    this.tramiteForm.get('primerApellidoResponsable')?.value && 
                    this.tramiteForm.get('segundoApellidoResponsable')?.value && 
                    this.tramiteForm.get('curpResponsable')?.value && 
                    this.tramiteForm.get('idCargo')?.value && 
                    this.tramiteForm.get('cargo')?.value);

        case 'firmaResponsable2':
          return !!(this.tramiteForm.get('firmantes_titulos_id2')?.value && 
                    this.tramiteForm.get('nombreResponsable2')?.value && 
                    this.tramiteForm.get('primerApellidoResponsable2')?.value && 
                    this.tramiteForm.get('segundoApellidoResponsable2')?.value && 
                    this.tramiteForm.get('curpResponsable2')?.value && 
                    this.tramiteForm.get('idCargo2')?.value && 
                    this.tramiteForm.get('cargo2')?.value);

        default:
          return false;
      }
    }





}